export default __webpack_public_path__ + "static/horta-b3e947bc7f1e5de1d5c7db07bca0b91b.jpg";